import { log, logMethodCall } from './debug';
import {
  CLEVERPUSH_BOUNCE_INITIAL_PATH,
  TRUE_STRING
} from '../const/common';
import {
  device,
  isHost
} from './env';

export function initBounce(url, notificationId, context) {
  logMethodCall('initBounce', url, notificationId);

  let bounced = false;
  if (!window?.history?.pushState) {
    return;
  }

  let initialBouncePath;
  try {
    initialBouncePath = sessionStorage.getItem(CLEVERPUSH_BOUNCE_INITIAL_PATH);
  } catch (err) {
    log.error(err);
  }
  if (!initialBouncePath) {
    initialBouncePath = location.pathname;
    sessionStorage.setItem(CLEVERPUSH_BOUNCE_INITIAL_PATH, location.pathname);
  }

  const setupBounce = () => {
    setTimeout(() => {
      window.addEventListener('popstate', () => {
        setTimeout(() => {
          if (sessionStorage.getItem('cleverpush-bounced') === TRUE_STRING) {
            return;
          }
          if (initialBouncePath !== location.pathname) {
            history.back();
            return;
          }

          bounced = !location.hash || location.href.indexOf('cleverPushBounceUrl') > -1;

          if (bounced && location.href.endsWith('#')) {
            // This was added for loberon.de as they change the hash to # when clicking on the quantity dropdown in the article selection
            bounced = false;
          }

          if (bounced) {
            sessionStorage.setItem('cleverpush-bounced', TRUE_STRING);

            const bounceParams = { channelId: context.config.channelId, notificationId, subscriptionId: context.subscriptionManager?.storageManager?.getSubscriptionId() };

            context.api.trackBounce(bounceParams);

            location.replace(url);
          }
        }, 0);
      }, false);
    }, 250);

    const initialUrl = location.pathname + (location.search || '') + (location.hash || '');

    setTimeout(() => {
      history.pushState({ cleverpushBounce: true }, document.title, location.pathname + (location.search || '') + (location.hash || ''));
      setTimeout(() => {
        history.replaceState(null, document.title, initialUrl);
      }, 150);
    }, 150);
    bounced = true;
  };

  if (document.readyState === 'completed' || document.readyState === 'complete' || document.readyState === 'interactive') {
    setupBounce();
  } else {
    window.addEventListener('load', setupBounce);
  }
}

export function initBounces(context) {
  logMethodCall('initBounces');

  try {
    let bounceUrl;
    if (isHost() && typeof URLSearchParams !== 'undefined') {
      let bounceDevice;
      let notificationId;
      if (location.search && location.search.length) {
        const params = new URLSearchParams(location.search.slice(1));
        bounceUrl = params.get('cleverPushBounceUrl');
        bounceDevice = params.get('cleverPushBounceDevice');
        notificationId = params.get('cleverPushNotificationId');
      }
      if (!bounceUrl && location.hash && location.hash.indexOf('#?') === 0) {
        const hashParams = new URLSearchParams(location.hash.slice(2));
        bounceUrl = hashParams.get('cleverPushBounceUrl');
        bounceDevice = hashParams.get('cleverPushBounceDevice');
        if (!notificationId) {
          notificationId = hashParams.get('cleverPushNotificationId');
        }
      }

      try {
        if (bounceUrl) {
          const decodedBounceUrlWithoutSpecialChars = decodeURIComponent(bounceUrl).replace(/[^\w:]/gi, '').toLowerCase();
          // eslint-disable-next-line no-script-url
          if (decodedBounceUrlWithoutSpecialChars.includes('javascript:')) {
            // prevent RXSS
            bounceUrl = undefined;
          }
        }
      } catch (exception) {
        // catches URI Malformed exception which might be used to bypass the above check
        bounceUrl = undefined;
      }

      if (bounceDevice && (
        (bounceDevice === 'mobile' && device.type !== 'mobile')
        || (bounceDevice === 'tablet' && device.type !== 'tablet')
        || (bounceDevice === 'desktop' && (device.type === 'table' || device.type === 'mobile')))
      ) {
        bounceUrl = undefined;
      }
      if (bounceUrl) {
        initBounce(bounceUrl, notificationId, context);
      }
    }

    if (!bounceUrl && context.config && context.config.bounceEnabled && context.config.bounceFilters && context.config.bounceFilters.length) {
      const fromNotification = document.referrer && (document.referrer.endsWith('cleverpush.com/worker.js') || document.referrer.endsWith(context.config.serviceWorkerFile || document.referrer.endsWith('/cleverpush-worker.js')));
      const fromSeo = document.referrer && /google|bing|yahoo|baidu|duckduckgo|wolframalpha/.test(document.referrer);
      const bounceFilter = context.config.bounceFilters.find((f) => {
        let should = (
          (!f.source || f.source === 'notification') && fromNotification)
          || (f.source === 'seo' && fromSeo)
          || ((!context.referrer || context.referrer === location.href) && f.source === 'direct')
          || (f.source === 'ignore');
        if (should && f.device) {
          should = (f.device === 'mobile' && device.type === 'mobile')
            || (f.device === 'tablet' && device.type === 'tablet')
            || (f.device === 'desktop' && device.type !== 'mobile' && device.type !== 'tablet');
        }
        if (should && f.matchQuery) {
          const params = new URLSearchParams(location.search.slice(1));
          Object.keys(f.matchQuery || {}).forEach((query) => {
            if (f.matchQuery[query]) {
              should = should && params.get(query) && params.get(query).includes(f.matchQuery[query]);
            }
          });
        }
        return should;
      });

      if (bounceFilter && bounceFilter.url) {
        initBounce(bounceFilter.url, null, context);
      }
    }

    if (sessionStorage.getItem('cleverpush-bounced') === TRUE_STRING && window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
      sessionStorage.removeItem('cleverpush-bounced');
      history.back();
    }
  } catch (err) {
    log.error(err);
  }
}
